import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import '../../../InteractiveVideo/Publish/PublishDialog/index.css';
import { Dialog, DialogContent } from '@material-ui/core';
import { hidePublishDialog } from '../../../../actions/interactiveVideos';
import CloseIcon from '../../../../assets/interactive/close.svg';
import SuccessGif from '../../../../assets/interactive/publish/success.gif';
// import LinkIcon from '../../../../assets/interactive/publish/link_external.svg';
import { Button } from '@mui/material';
import variables from '../../../../utils/variables';
// import { appsLinks } from '../../../../config';
import Lottie from 'lottie-react';
import BackgroundWavesAnimation from '../../../../assets/Abstract_waves_circles.json';
import withRouter from '../../../../components/WithRouter';

const PublishDialog = (props) => {
    // const idIV = props.result && props.result._id;
    // const handleTv = () => {
    //     window.open(`${appsLinks.TV}/iv/${idIV}`);
    // };

    const handleClose = () => {
        props.hidePublishDialog();
    };

    return (
        <Dialog
            aria-labelledby="publish-dialog"
            className="dialog publish_dialog"
            open={props.open}
            onClose={handleClose}>
            <DialogContent className="dialog_content">
                <Lottie animationData={BackgroundWavesAnimation} className="background_waves" loop={true}/>
                <div className="success_dialog">
                    <img alt="CloseIcon" className="close_icon" src={CloseIcon} onClick={handleClose}/>
                    <img alt="SuccessGif" className="success_gif" src={SuccessGif}/>
                    <p style={{ marginBottom: '20px' }}>{variables[props.lang]['your_video_published']}</p>
                    {/* <div onClick={handleTv}> */}
                    {/*    <p>{variables[props.lang]['view_on_tv']}</p> */}
                    {/*    <img alt="Link Icon" src={LinkIcon}/> */}
                    {/* </div> */}
                    <Button onClick={handleClose}>{variables[props.lang].done}</Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

PublishDialog.propTypes = {
    hidePublishDialog: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    publishID: PropTypes.string.isRequired,
    result: PropTypes.object.isRequired,
};

const stateToProps = (state) => {
    return {
        lang: state.language,
        open: state.interactiveVideos.publishDialog.open,
        result: state.interactiveVideos.newFile.interactiveVideo.result,
        publishID: state.assetPublish.publishID.value,
    };
};

const actionToProps = {
    hidePublishDialog,
};

export default withRouter(connect(stateToProps, actionToProps)(PublishDialog));
